import React, { useState, useEffect } from "react";
import PageHeader from "@atlaskit/page-header";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { getApiData } from "../../actions";
import { useStateValue } from "../../contexts/AppContext";
import axios from "axios";
import formatOptions from "../../helpers/formatOptions";
import Page from "../../components/Page";
import ChipList from "../../components/ChipList";

const noData = { races: [], racePointsCompetitor: [] };
const noEkipniData = { rounds: [], clubs: [] };

const yearOptions = Array.from(
  { length: new Date().getFullYear() - 2018 },
  (_, index) => {
    return { value: 2019 + index, label: 2019 + index };
  }
);

const ageGroupDelta = (category) => {
  return category.name === "APSOLUTNO" ? 5 : 2;
};

const removeCups = (cups, selectedYear) => {
  if (selectedYear < 2020) {
    cups = cups.filter((cup) => cup.id < 4);
  } else if (selectedYear >= 2020) {
    cups = cups.filter((cup) => [4].includes(cup.id));
  }
  return cups;
};

const Cup = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [categoryId, setCategoryId] = useState(null);
  const [category, setCategory] = useState(null);
  const [cupId, setCupId] = useState(4);
  const [cupName, setCupName] = useState("");
  const [data, setData] = useState(noData);
  const [ekipniData, setEkipniData] = useState(noEkipniData);
  const [showEkipni, setShowEkipni] = useState(false);
  const [state, dispatch] = useStateValue();
  const [minAge, setMinAge] = useState(null);

  useEffect(() => {
    document.title = "Kup Hrvatske";
    getApiData("categories", "/api/category", dispatch);
    getApiData("cups", "/api/cup", dispatch);
  }, []);
  console.log({ minAge });
  const extraParams = minAge
    ? ageGroupDelta(category) === 2
      ? { minAge: minAge - 1, maxAge: minAge + ageGroupDelta(category) - 2 }
      : { minAge, maxAge: minAge + ageGroupDelta(category) - 1 }
    : {};

  const generateXlsUrl = () => {
    const params = {
      cupId,
      categoryId,
      year,
      ...extraParams,
    };
    return (
      "/api/kup.xls?" +
      Object.entries(params).reduce(
        (acc, cur, index) =>
          acc + (index > 0 ? "&" : "") + cur[0] + "=" + cur[1],
        ""
      )
    );
  };

  const getCup = async () => {
    if (cupId && categoryId && year) {
      try {
        const cup = await axios.get(`/api/cupOrder`, {
          params: {
            cupId,
            categoryId,
            year,
            ...extraParams,
          },
        });
        if (cup.status === 200) {
          //Sort race points
          if (cup.data.racePointsCompetitor) {
            cup.data.racePointsCompetitor.forEach((competitor, index) => {
              cup.data.racePointsCompetitor[
                index
              ].racePoints = cup.data.racePointsCompetitor[
                index
              ].racePoints.sort((a, b) => a.points < b.points);
            });
          }

          return setData(cup.data);
        } else {
          console.log("Error");
          return setData(noData);
        }
      } catch (e) {
        console.log(e);
      }
      return setData(noData);
    }
  };

  const getEkipni = async () => {
    if (cupId && year) {
      try {
        const res = await axios.get(`/api/ekipniHtl`, {
          params: { cupId, year },
        });
        if (res.status === 200) {
          setEkipniData(res.data);
        } else {
          setEkipniData(noEkipniData);
        }
      } catch (e) {
        console.log(e);
        setEkipniData(noEkipniData);
      }
    }
  };

  useEffect(() => {
    getCup();
  }, [year, categoryId, cupId, minAge]);

  useEffect(() => {
    if (showEkipni) getEkipni();
  }, [showEkipni, cupId, year]);

  useEffect(() => {
    if (state.apiData["cups"] && !state.apiData["cups"][3]) {
      return;
    }
    if (state.apiData["cups"] && state.apiData["cups"].length) {
      setCupId(state.apiData["cups"][3].id);
      setCupName(state.apiData["cups"][3].name);
    }
  }, [state.apiData["cups"]]);

  useEffect(() => {
    if (state.apiData["categories"] && state.apiData["categories"].length) {
      setCategoryId(
        (
          state.apiData["categories"].sort((a, b) => a.id > b.id)[8] ||
          state.apiData["categories"].sort((a, b) => a.id > b.id)[0]
        ).id
      );
      setCategory(
        state.apiData["categories"][8] || state.apiData["categories"][0]
      );
    }
  }, [state.apiData["categories"]]);

  return (
    <Page
      title="Kup Hrvatske"
      toolBarActions={["settings", { type: "data", url: generateXlsUrl() }]}
      search={
        <>
          {state.apiData["cups"] && (
            <ChipList
              defaultValue={
                (formatOptions(state.apiData["cups"])[3] &&
                  formatOptions(state.apiData["cups"])[3].value) ||
                formatOptions(state.apiData["cups"])[0].value
              }
              options={formatOptions(removeCups(state.apiData["cups"], year))}
              onChange={(option) => {
                if (option) {
                  setCupId(option.value);
                  setCupName(option.label);
                  setMinAge(null);
                }
              }}
            />
          )}
          <br />
          <ChipList
            defaultValue={new Date().getFullYear()}
            options={yearOptions}
            onChange={(option) => {
              if (option) {
                setYear(option.value);
                setMinAge(null);
              }
            }}
          />
          <br />
          {state.apiData["categories"] && (
            <ChipList
              defaultValue={
                (
                  formatOptions(state.apiData["categories"])[8] ||
                  formatOptions(state.apiData["categories"])[0]
                ).value
              }
              options={formatOptions(state.apiData["categories"])
                .filter((category) => {
                  if (year >= 2020) {
                    return true;
                  }
                  if (cupName.includes("Mini")) {
                    return category.label.toLowerCase().includes("etnici");
                  } else {
                    return !category.label.toLowerCase().includes("etnici");
                  }
                })
                .sort((a, b) =>
                  a.label.toLowerCase().includes("etnici") ? 1 : -1
                )
                .map((a) => {
                  if (a.label === "POČETNICI B M") {
                    a.breakLine = true;
                  }
                  return a;
                })}
              onChange={(option) => {
                if (option) {
                  setCategoryId(option.value);
                  setCategory(
                    state.apiData["categories"].find(
                      (cat) => cat.id === option.value
                    )
                  );
                  setMinAge(null);
                }
              }}
            />
          )}
          <br />
          {category && !cupName.includes("Mini") && (
            <ChipList
              value={minAge}
              options={Array.from(
                { length: ageGroupDelta(category) < 5 ? 2 : 15 },
                (value, index) => {
                  if (category.name.includes("APS")) {
                    const ageCount = 20 + index * ageGroupDelta(category);
                    return {
                      label: category.sex + " " + ageCount,
                      value: ageCount,
                    };
                  } else if (category.name.includes("JUNIORI")) {
                    const ageCount = 17 + index * 2;
                    return {
                      label: "U " + ageCount,
                      value: ageCount,
                    };
                  } else if (category.name.includes("KADETI")) {
                    const ageCount = 13 + index * 2;
                    return {
                      label: "U " + ageCount,
                      value: ageCount,
                    };
                  }
                }
              )}
              onChange={(option) => {
                if (option) {
                  setMinAge(option.value);
                }
              }}
            />
          )}
        </>
      }
    >
      <PageHeader>{cupName}</PageHeader>
      <div style={{ marginBottom: 12 }}>
        <button
          onClick={() => setShowEkipni((v) => !v)}
          style={{
            padding: "6px 16px",
            borderRadius: 4,
            border: "1px solid #3947A6",
            background: showEkipni ? "#3947A6" : "#fff",
            color: showEkipni ? "#fff" : "#3947A6",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Ekipni HTL
        </button>
      </div>

      {showEkipni && (
        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              background: "#f5f6fa",
              border: "1px solid #dde0e8",
              borderRadius: 6,
              padding: "12px 16px",
              marginBottom: 16,
              fontSize: 13,
              color: "#454136",
            }}
          >
            <b>Pravila ekipnog bodovanja:</b>
            <ol style={{ margin: "6px 0 0 0", paddingLeft: 18 }}>
              <li>Za svaku kategoriju (seniori, seniorke, juniori, juniorke, kadeti, kadetkinje, U11, U9) gleda se plasman najboljeg člana kluba.</li>
              <li>Ostvareni plasmani zbrajaju se u ukupni bodovni poredak za pojedino kolo lige.</li>
              <li>Klubovima bez predstavnika u određenoj kategoriji dodjeljuje se broj bodova jednak plasmanu posljednjeg sudionika u toj kategoriji uvećan za 1.</li>
              <li>Klub s najmanje ukupnih bodova u pojedinom kolu proglašava se pobjednikom kola.</li>
              <li>Na kraju sezone, klub s najmanjim zbrojem bodova iz svih kola osvaja ekipni naslov.</li>
            </ol>
          </div>

          {cupId && year && (
            <ReactTable
              showPagination={false}
              data={ekipniData.clubs}
              columns={[
                {
                  Header: "",
                  accessor: "position",
                  maxWidth: 50,
                  minWidth: 40,
                  expander: false,
                },
                {
                  Header: "Klub",
                  accessor: "clubName",
                  minWidth: 200,
                  maxWidth: 300,
                  Cell: (row) => (
                    <Link to={"/clubs/" + row.original.clubId}>
                      {row.value.replace("Triatlon klub", "").trim()}
                    </Link>
                  ),
                },
                {
                  Header: "UKUPNO",
                  accessor: "seasonScore",
                  maxWidth: 90,
                  minWidth: 80,
                  getProps: () => ({
                    style: { background: "#3947A644", color: "#454136" },
                  }),
                  Cell: (row) => (
                    <span>
                      <b>{row.value}</b>
                    </span>
                  ),
                },
                ...ekipniData.rounds.map((roundDate, index) => ({
                  Header: `${index + 1}. kolo`,
                  id: `round_${roundDate}`,
                  maxWidth: 90,
                  minWidth: 70,
                  accessor: (row) => {
                    const round = (row.rounds || []).find(
                      (r) => r.roundDate === roundDate
                    );
                    return round ? round.roundScore : "-";
                  },
                  Cell: (row) => <span>{row.value}</span>,
                })),
              ]}
              SubComponent={(row) => {
                const rounds = row.original.rounds || [];
                const allCategories = rounds.length > 0
                  ? (rounds[0].categories || []).map((c) => ({ id: c.categoryId, name: c.category }))
                  : [];
                return (
                  <div style={{ padding: "12px 24px", background: "#fafbff", overflowX: "auto" }}>
                    <table style={{ borderCollapse: "collapse", fontSize: 12, width: "100%" }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: "left", padding: "4px 12px 4px 0", color: "#666", fontWeight: 600, borderBottom: "1px solid #dde0e8", minWidth: 120 }}>
                            Kategorija
                          </th>
                          {rounds.map((r, i) => (
                            <th key={r.roundDate} style={{ textAlign: "left", padding: "4px 12px", color: "#666", fontWeight: 600, borderBottom: "1px solid #dde0e8", minWidth: 180 }}>
                              {i + 1}. kolo ({r.roundDate})
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {allCategories.map((cat) => (
                          <tr key={cat.id} style={{ verticalAlign: "top" }}>
                            <td style={{ padding: "6px 12px 6px 0", fontWeight: 600, whiteSpace: "nowrap" }}>{cat.name}</td>
                            {rounds.map((r) => {
                              const entry = (r.categories || []).find((c) => c.categoryId === cat.id);
                              const present = entry && entry.isPresent;
                              const competitors = entry && entry.competitors ? entry.competitors : [];
                              return (
                                <td key={r.roundDate} style={{ padding: "6px 12px", borderLeft: "1px solid #eef0f5" }}>
                                  {present ? (
                                    <div>
                                      {competitors.map((c, ci) => (
                                        <div key={ci} style={{
                                          color: ci === 0 ? "#3947A6" : "#888",
                                          fontWeight: ci === 0 ? 700 : 400,
                                          lineHeight: "1.6",
                                        }}>
                                          {c.placement}. {c.name}
                                          {ci === 0 && (
                                            <span style={{ marginLeft: 6, fontSize: 11, background: "#3947A6", color: "#fff", borderRadius: 3, padding: "1px 5px" }}>
                                              plasman: {entry.score}
                                            </span>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <span style={{ color: "#bbb", fontStyle: "italic" }}>
                                      nema ({entry ? entry.score : "-"})
                                    </span>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                        <tr style={{ borderTop: "2px solid #dde0e8" }}>
                          <td style={{ padding: "6px 12px 6px 0", fontWeight: 700 }}>Ukupno</td>
                          {rounds.map((r) => (
                            <td key={r.roundDate} style={{ padding: "6px 12px", fontWeight: 700, color: "#3947A6", borderLeft: "1px solid #eef0f5" }}>
                              {r.roundScore} bodova
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ fontSize: 11, color: "#aaa", marginTop: 6 }}>nema = nema predstavnika – dodjeljuje se plasman posljednjeg + 1</div>
                  </div>
                );
              }}
              defaultPageSize={50}
              pageSize={ekipniData.clubs.length || 10}
              className="-striped -highlight"
            />
          )}
        </div>
      )}

      {!showEkipni && cupId && categoryId && year && (
        <ReactTable
          showPagination={false}
          data={data.racePointsCompetitor}
          columns={[
            {
              Header: "",
              accessor: "position",
              maxWidth: 50,
              minWidth: 40,
            },
            {
              Header: "Ime i prezime",
              accessor: "name",
              minWidth: 200,
              maxWidth: 200,
              Cell: (row) => (
                <Link to={"/competitors/" + row.original.id}>
                  {row.original.name} {row.original.surname}
                </Link>
              ),
            },
            {
              Header: "Klub",
              accessor: "clubName",
              maxWidth: 100,
              Cell: (row) => (
                <Link to={"/clubs/" + row.original.clubId}>
                  {row.value.replace("Triatlon klub", "")}
                </Link>
              ),
            },
            {
              Header: "UKUPNO",
              accessor: "totalPoints",
              maxWidth: 80,
              minWidth: 80,
              getProps: () => {
                return {
                  style: {
                    background: "#3947A644",
                    color: "#454136",
                  },
                };
              },
              Cell: (row) => (
                <span>
                  <b>{row.value}</b>
                </span>
              ),
            },
            ...data.races.map((race) => {
              return {
                Header: <Link to={"/races/" + race.id}>{race.name}</Link>,
                minWidth: 50,
                maxWidth: 100,
                accessor: "racePoints",
                Cell: (row) => {
                  const targetRace = row.original.racePoints.find(
                    (r) => r.raceId === race.id
                  );
                  const points =
                    targetRace && targetRace.points ? targetRace.points : 0;
                  if (points > 0) {
                    if (targetRace.isCountingToFinal) {
                      return (
                        <span style={{ color: "blue" }}>
                          <b>{points}</b>
                        </span>
                      );
                    }
                    return <span>{points}</span>;
                  }
                  return <span>{points}</span>;
                },
              };
            }),
            ...(year > 2020 &&
            [1, 2].includes(categoryId) &&
            !data.races.find((race) => race.maxPoints === 300)
              ? [
                  {
                    Header: " ",
                    accessor: "qualifyPoints",
                    minWidth: 100,
                    Cell: (row) => {
                      return <span />;
                    },
                  },
                  {
                    Header: "Kvalifikacijski bodovi",
                    accessor: "qualifyPoints",
                    maxWidth: 200,
                    minWidth: 80,
                    Cell: (row) => {
                      if (
                        row.original.quilifyRank <=
                          (year >= 2026 ? 70 : 60) &&
                        row.original.qualifyPoints >= 0
                      ) {
                        return (
                          <span style={{ color: "blue" }}>
                            <b>{row.value}</b>
                          </span>
                        );
                      } else {
                        return (
                          <span style={{ color: "red" }}>
                            <b>{row.value}</b>
                          </span>
                        );
                      }
                    },
                  },
                  {
                    Header: "Kvalifikacijski poredak",
                    accessor: "quilifyRank",
                    maxWidth: 200,
                    minWidth: 80,
                    Cell: (row) => {
                      if (
                        row.original.quilifyRank <=
                          (year >= 2026 ? 70 : 60) &&
                        row.original.qualifyPoints >= 0
                      ) {
                        return (
                          <span style={{ color: "blue" }}>
                            <b>{row.value}</b>
                          </span>
                        );
                      } else {
                        return (
                          <span style={{ color: "red" }}>
                            <b>{row.value}</b>
                          </span>
                        );
                      }
                    },
                  },
                ]
              : []),
          ]}
          defaultPageSize={50}
          pageSize={data.racePointsCompetitor.length || 20}
          className="-striped -highlight"
        />
      )}
    </Page>
  );
};

export default Cup;
